<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<div fxFlex>
		<div>{{ data.title }}</div>
	</div>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<div class="m-t-1">
		<mat-radio-group [(ngModel)]="procureCarriersChoice" fxFlex>
			<div *ngFor="let entry of ADD_CARRIERS_TO_PROJECT_OPTIONS | keyvalue; let isLast = last">
				<mat-radio-button
					class="fs-18 m-t-1"
					[ngClass]="{ 'm-b-1': isLast }"
					color="primary"
					[value]="entry.key"
				>
					{{ entry.value }}
				</mat-radio-button>
			</div>
		</mat-radio-group>
	</div>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex fxLayoutAlign="end end" fxLayoutGap="1rem">
		<button (click)="closeDialog()" color="primary" mat-stroked-button>Cancel</button>
		<button
			(click)="selectOption()"
			*ngIf="!isRequestInProgress"
			color="primary"
			mat-raised-button
			[disabled]="IS_NULL_OR_UNDEFINED(procureCarriersChoice)"
		>
			Add
		</button>
		<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
	</div>
</mat-dialog-actions>
